<template>
  <svg
    :height="size"
    :width="size"
    fill="none"
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :fill="fill"
      d="M15 24.375C5.18602 24.375 0.320391 15.8194 0.118125 15.4554C-0.039375 15.172 -0.039375 14.8277 0.118125 14.5444C0.320391 14.1806 5.18602 5.625 15 5.625C24.814 5.625 29.6796 14.1806 29.8819 14.5446C30.0394 14.828 30.0394 15.1723 29.8819 15.4556C29.6796 15.8194 24.814 24.375 15 24.375ZM2.0407 14.9986C3.15586 16.6887 7.53422 22.5 15 22.5C22.4895 22.5 26.8484 16.6934 27.9593 15.0014C26.8441 13.3113 22.4658 7.5 15 7.5C7.51055 7.5 3.15164 13.3066 2.0407 14.9986ZM15 20.625C11.8983 20.625 9.375 18.1017 9.375 15C9.375 11.8983 11.8983 9.375 15 9.375C18.1017 9.375 20.625 11.8983 20.625 15C20.625 18.1017 18.1017 20.625 15 20.625ZM15 11.25C12.9323 11.25 11.25 12.9323 11.25 15C11.25 17.0677 12.9323 18.75 15 18.75C17.0677 18.75 18.75 17.0677 18.75 15C18.75 12.9323 17.0677 11.25 15 11.25Z"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { iconProps } from '../../IconProps';

export default defineComponent({
  name: 'IconShow',
  props: {
    ...iconProps,
  },
});
</script>
